import React from "react";
import Navbar from "./comp/Navbar";
import SearchField from "./comp/SearchField";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Navbar />
      <SearchField />
    </div>
  );
}

export default App;
